"use strict";

var waypoint = new Waypoint({
  element: document.getElementById('waypoint'),
  handler: function handler(direction) {
    var count = new CountUp("stat-1", 0, 139357693);
    count.start();
    var count1 = new CountUp("stat-2", 0.0, 1.1, 1, {
      decimal: 1
    });
    count1.start();
    var count2 = new CountUp("stat-3", 0.0, 5.1, 1, {
      decimal: 1
    });
    count2.start();
    waypoint.destroy();
  },
  offset: '95%'
}); // FUNCTIONS

/**
 * Swaps out the video in the main player
 *
 * @param {string} source   - The file name of the video
 */

function swapVideo(evt, source) {
  var videoContainer = $('.igv-wwu-vid__play');
  var buttonContainer = $('.igv-wwu-vid__btns');
  var videoHTML = "<iframe src=\"".concat(source, "?rel=0\"\n                         class=\"vid-frame\"\n                         frameborder=\"0\"\n                         allowfullscreen=\"true\"></iframe>"); // Fading out the video

  videoContainer.animate({
    opacity: 0
  }, 250, function () {
    // Swapping out the video and fading in
    videoContainer.html(videoHTML).delay(100).animate({
      opacity: 1
    }, 250);
  });
  var vid_buttons = buttonContainer[0].getElementsByTagName("button");
  console.log(vid_buttons);

  for (i = 0; i < vid_buttons.length; i++) {
    vid_buttons[i].className = vid_buttons[i].className.replace(" active", "");
  }

  evt.currentTarget.className += " active";
} // var	testim = document.getElementById("testim"),
// 	testimDots = Array.prototype.slice.call(document.getElementById("testim-dots").children),
//     testimContent = Array.prototype.slice.call(document.getElementById("testim-content").children),
//     testimLeftArrow = document.getElementById("left-arrow"),
//     testimRightArrow = document.getElementById("right-arrow"),
//     testimSpeed = 4500,
//     currentSlide = 0,
//     currentActive = 0,
//     testimTimer,
// 	touchStartPos,
// 	touchEndPos,
// 	touchPosDiff,
// 	ignoreTouch = 30;
// ;
// window.load(function() {
//     // Testim Script
//     function playSlide(slide) {
//         for (var k = 0; k < testimDots.length; k++) {
//             testimContent[k].classList.remove("active");
//             testimContent[k].classList.remove("inactive");
//             testimDots[k].classList.remove("active");
//         }
//         if (slide < 0) {
//             slide = currentSlide = testimContent.length-1;
//         }
//         if (slide > testimContent.length - 1) {
//             slide = currentSlide = 0;
//         }
//         if (currentActive != currentSlide) {
//             testimContent[currentActive].classList.add("inactive");            
//         }
//         testimContent[slide].classList.add("active");
//         testimDots[slide].classList.add("active");
//         currentActive = currentSlide;
//         clearTimeout(testimTimer);
//         testimTimer = setTimeout(function() {
//             playSlide(currentSlide += 1);
//         }, testimSpeed)
//     }
//     testimLeftArrow.addEventListener("click", function() {
//         playSlide(currentSlide -= 1);
//     })
//     testimRightArrow.addEventListener("click", function() {
//         playSlide(currentSlide += 1);
//     })    
//     for (var l = 0; l < testimDots.length; l++) {
//         testimDots[l].addEventListener("click", function() {
//             playSlide(currentSlide = testimDots.indexOf(this));
//         })
//     }
//     playSlide(currentSlide);
//     // keyboard shortcuts
//     document.addEventListener("keyup", function(e) {
//         switch (e.keyCode) {
//             case 37:
//                 testimLeftArrow.click();
//                 break;
//             case 39:
//                 testimRightArrow.click();
//                 break;
//             case 39:
//                 testimRightArrow.click();
//                 break;
//             default:
//                 break;
//         }
//     })
// 		testim.addEventListener("touchstart", function(e) {
// 				touchStartPos = e.changedTouches[0].clientX;
// 		})
// 		testim.addEventListener("touchend", function(e) {
// 				touchEndPos = e.changedTouches[0].clientX;
// 				touchPosDiff = touchStartPos - touchEndPos;
// 				console.log(touchPosDiff);
// 				console.log(touchStartPos);	
// 				console.log(touchEndPos);	
// 				if (touchPosDiff > 0 + ignoreTouch) {
// 						testimLeftArrow.click();
// 				} else if (touchPosDiff < 0 - ignoreTouch) {
// 						testimRightArrow.click();
// 				} else {
// 					return;
// 				}
// 		})
// })